import { Grid, GridJustification } from "@material-ui/core";
import PropTypes from "prop-types";
import { CSSProperties, ReactNode } from "react";

const TabPanel = ({
  children,
  value,
  index,
  justifyContent,
  styles,
  className,
}: {
  children: ReactNode;
  value: number;
  index: number;
  justifyContent?: GridJustification;
  styles?: CSSProperties;
  className?: string;
}) => {
  return (
    <>
      {value === index && (
        <Grid
          container
          item
          xs
          className={className}
          role="tabpanel"
          hidden={value !== index}
          id={`simple-tabpanel-${index}`}
          aria-labelledby={`simple-tab-${index}`}
          justifyContent={justifyContent}
          style={{ ...styles }}
        >
          {children}
        </Grid>
      )}
    </>
  );
};

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
  justifyContent: PropTypes.string,
  style: PropTypes.object,
};

export default TabPanel;
